import { apiGet } from '../client';
import { BookingFeesSchema, type BookingFees } from '../schemas';

/** What the business owes Dale for bookings from the app (owner only on the server). */
export function getBookingFees(): Promise<BookingFees> {
  return apiGet('/v1/business/booking-fees', BookingFeesSchema);
}
